import type {
    CommerceDisposedEvent,
    CommerceDisposedListener,
    CommerceEventUnsubscribe,
    CommerceLifecycle,
} from "@teqtank/commerce-contracts";
import { DisposableListenerRegistry } from "../events/disposable-listener-registry.js";

export class CommerceLifecycleController implements CommerceLifecycle {
    private readonly disposedListeners = new DisposableListenerRegistry<CommerceDisposedEvent>();
    private disposed = false;

    public get isReady(): boolean {
        return !this.disposed;
    }

    public get isDisposed(): boolean {
        return this.disposed;
    }

    public onDisposed(listener: CommerceDisposedListener): CommerceEventUnsubscribe {
        return this.disposedListeners.subscribe(listener);
    }

    public dispose(): CommerceDisposedEvent | undefined {
        if (this.disposed) {
            return undefined;
        }

        this.disposed = true;
        const event: CommerceDisposedEvent = Object.freeze({
            disposedAt: new Date(),
        });
        this.disposedListeners.emit(event);
        this.disposedListeners.release();

        return event;
    }
}
